import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { NgSelectModule } from '@ng-select/ng-select';
import * as XLSX from 'xlsx';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';

@Component({
  selector: 'app-approval-matrix-form-filter',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './approval-matrix-form-filter.component.html',
  styleUrl: './approval-matrix-form-filter.component.scss',
})
export class ApprovalMatrixFormFilterComponent {
  isDisabled: boolean = false;
  ApplicabilityDatas = [] as any;
  @Input() Title: string = '';
  @Input() ShowFilter = {
    ShowBranch: false,
    ShowClient: false,
    ShowSite: false,
    ShowSearchEmployee: false,
  }
  @Input() WebESSApplicabilityId = null;
  @Input() EmpType = null;
  @Input() Type = 'P';
  @Input() IsSubContractor = false;
  @Input() Limit = 0;
  @Input() ShowSample = true;
  @Input() ShowUpload = true;

  Filter = {
    BranchID: 0,
    ClientID: 0,
    SiteID: 0,
    SearchText: null
  }

  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;

  BulkData: any[] = [];
  Employees = [] as any;
  public User: any = null;
  constructor(
    private activeModal: NgbActiveModal,
    private combo: ComboService,
    private toast: ToastService,
    private download: DownloadSampleService,
    private sessionService: SessionService,
    private approvalmatrixservice: ApprovalMatrixService,
    private employeeRegistration: EmployeeRegistrationService,
  ) { }

  ngOnInit(): void {
    if (this.ShowFilter.ShowBranch) {
      this.ApprovalComboLoad('Branch');
    }
    if (this.ShowFilter.ShowClient) {
      this.ApprovalComboLoad('Client');
    }
    if (this.ShowFilter.ShowSite) {
      this.ApprovalComboLoad('Site');
    }

    console.log(this.Title);
    console.log(this.ShowFilter);
    console.log(this.WebESSApplicabilityId);
    console.log(this.EmpType);
  }

  ApprovalComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.Branchs = response.Table;
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close(isClose: boolean) {
    if (this.WebESSApplicabilityId == 8 || isClose) {
      this.activeModal.close();
    } else {
      this.activeModal.close(this.Filter);
    }
  }

  ok() {
    if (this.Employees.length > 0) {
      if (this.WebESSApplicabilityId == 8 || this.WebESSApplicabilityId == 4) {
        this.activeModal.close(this.Employees);
      }
    } else {
      this.toast.show({ message: this.WebESSApplicabilityId == 8 ? 'Please enter atleast one employee' : this.WebESSApplicabilityId == 4 ? 'Please enter atleast one sites' : '', type: toastTypeEnum.warning });
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'EmpCode': this.Filter.SearchText, 'EmpType': this.EmpType, }).subscribe({
      next: (response) => {
        if (Combotype == 'EmpLoad') {
          if (response.ComboLoad != undefined && response.ComboLoad.length > 0) {
            this.Employees.push(response.ComboLoad[0]);
            this.toast.show({ message: "Employee added in list", type: toastTypeEnum.success });
          } else {
            this.toast.show({ message: "Employee not found", type: toastTypeEnum.warning });
          }
        }
        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  search(type: string) {
    if (this.Limit == 0 || this.Employees.length < this.Limit) {
      if (type == 'Employee' && this.WebESSApplicabilityId == 8) {
        if (this.Filter.SearchText != null && this.Filter.SearchText != '') {
          if (this.Employees.filter((e: any) => e.EmpCode == this.Filter.SearchText).length == 0) {
            if (this.IsSubContractor) {
              this.ESS_EmployeeSubcontracterSelect();
            } else {
              this.ComboLoad('EmpLoad');
            }
          } else {
            this.toast.show({ message: "Employee already exsit in list", type: toastTypeEnum.warning });
          }
        } else {
          this.toast.show({ message: "Please enter employee code", type: toastTypeEnum.warning });
        }
      } else if (this.WebESSApplicabilityId == 4) {
        if (this.Filter.SearchText != null && this.Filter.SearchText != '') {

          this.isDisabled = true;
          this.approvalmatrixservice.ESS_GetDataOnMultipleCode({
            SelectType: 'Site',
            Code: this.Filter.SearchText,
          }).subscribe(
            (data: any) => {
              if (data.Table.length > 0) {
                const newEmployees = Object.values(data.Table) as { SiteMasterID: any, SiteCode: any; SiteName: string; }[];
                const uniqueNewEmployees = newEmployees.filter(newEmp => !this.Employees.some((existingEmp: { SiteCode: any; }) => existingEmp.SiteCode === newEmp.SiteCode));
                this.Employees = [...this.Employees, ...uniqueNewEmployees];
                const rowCount = uniqueNewEmployees.length;
                if (rowCount > 0) {
                  this.toast.show({ message: `${rowCount} Site Added to the List!`, type: toastTypeEnum.success });
                } else {
                  this.toast.show({ message: `Site already added to the List!`, type: toastTypeEnum.warning });
                }
              } else {
                this.toast.show({ message: `Site not fonud!`, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            error => {
              console.error('Error:', error);
              this.isDisabled = false;
            }
          );
        } else {
          this.toast.show({ message: "Please enter site code", type: toastTypeEnum.warning });
        }
      }
    } else {
      this.toast.show({ message: "Allow only " + this.Limit.toString() + " in list, please remove and add", type: toastTypeEnum.warning });
    }

  }

  Delete(type: string, index: number) {
    if (type == 'Employee' || type == 'Site') {
      this.Employees.splice(index, 1);
    }
  }
  //Added By Pooja on 05 July 2024 as per discussion with Suhas sir
  handleFileInput(event: any): void {
    this.BulkData.length = 0;
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }

  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        const headerRow = excelData[0];
        const headers = headerRow.map((header: string) => header.trim());
        const dataRows = excelData.slice(1);

        const uniqueIds: Set<number> = new Set();
        //const FullNames: Set<string> = new Set();
        const tempEmployees: any[] = [];
        let hasError = false;

        for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
          const row = dataRows[rowIndex];
          const rowData: any = {};

          row.forEach((cellData, index) => {
            rowData[headers[index]] = cellData;
          });

          let id = null;
          let FullName = null;

          if (this.WebESSApplicabilityId == 8) {
            id = rowData['EmpCode'];
            FullName = rowData['FullName'];
            FullName = FullName ? FullName.trim() : '';
          } else if (this.WebESSApplicabilityId == 4) {
            id = rowData['SiteCode'];
          }


          if (id === '' || id === null || id === undefined) {
            if (this.WebESSApplicabilityId == 8) {
              this.toast.show({ message: `Employee Code is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            } else if (this.WebESSApplicabilityId == 4) {
              this.toast.show({ message: `Site Code is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            }
            hasError = true;
            break;
          }
          else if (id !== 0 && uniqueIds.has(id)) {
            if (this.WebESSApplicabilityId == 8) {
              this.toast.show({ message: `Duplicate Employee Code '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            } else if (this.WebESSApplicabilityId == 4) {
              this.toast.show({ message: `Duplicate Site Code '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            }
            hasError = true;
            break;
          }
          else if (this.WebESSApplicabilityId == 8 && (FullName === '' || FullName === null || FullName === undefined)) {
            this.toast.show({ message: `FullName name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            hasError = true;
            break;
          }
          else {
            uniqueIds.add(id);
          }

          if (this.WebESSApplicabilityId == 8) {
            rowData['FullName'] = FullName;
          }
          tempEmployees.push(rowData);
        }
        if (!hasError) {
          this.BulkData.push(...tempEmployees);
          if (this.BulkData.length > 0) {
            this.BulkInsertUpdate();
          }
        }
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }

  // BulkInsertUpdate() {
  //   this.User = this.sessionService.GetUserDetails();
  //   if (this.BulkData.length === 0) {
  //     this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
  //     return
  //   }
  //   const empCodes = this.BulkData.map(item => item.EmpCode).join(',');
  //   const BulkData = {
  //     SelectType: 'GetEmpCode',
  //     EmpCodes: empCodes,
  //     EmpType: this.EmpType,
  //   };
  //   console.log('Error:', BulkData);
  //   this.isDisabled = true
  //   this.approvalmatrixservice.ESS_CheckEMPCode(BulkData).subscribe(
  //     data => { 
  //       this.Employees = Object.values(data.Table);
  //       const rowCount = this.Employees.length;
  //       this.toast.show({ message: `${rowCount} Employees Added in the List!`, type: toastTypeEnum.success });
  //       this.isDisabled = false
  //     },
  //     error => {
  //       console.error('Error:', error);
  //       this.isDisabled = false
  //     });
  // }

  BulkInsertUpdate() {
    this.User = this.sessionService.GetUserDetails();
    if (this.BulkData.length === 0) {
      this.toast.show({ message: 'No Data Available!', type: toastTypeEnum.warning });
      return;
    }

    if (this.WebESSApplicabilityId == 8) {
      this.isDisabled = true;
      this.approvalmatrixservice.ESS_CheckEMPCode({
        SelectType: 'GetEmpCode',
        EmpCodes: this.BulkData.map(item => item.EmpCode).join(','),
        EmpType: this.IsSubContractor ? 'subcontractor' : this.EmpType,
      }).subscribe(
        (data: any) => {
          const newEmployees = Object.values(data.Table) as { EmpCode: any; FullName: string; }[];
          const uniqueNewEmployees = newEmployees.filter(newEmp => !this.Employees.some((existingEmp: { EmpCode: any; }) => existingEmp.EmpCode === newEmp.EmpCode));
          this.Employees = [...this.Employees, ...uniqueNewEmployees];
          const rowCount = uniqueNewEmployees.length;
          this.toast.show({ message: `${rowCount} Employees Added to the List!`, type: toastTypeEnum.success });
          this.isDisabled = false;
          console.log('all employee Data', this.Employees);
        },
        error => {
          console.error('Error:', error);
          this.isDisabled = false;
        }
      );
    } else {
      this.isDisabled = true;
      this.approvalmatrixservice.ESS_GetDataOnMultipleCode({
        SelectType: 'Site',
        Code: this.BulkData.map(item => item.SiteCode).join(','),
      }).subscribe(
        (data: any) => {
          const newEmployees = Object.values(data.Table) as { SiteMasterID: any, SiteCode: any; SiteName: string; }[];
          const uniqueNewEmployees = newEmployees.filter(newEmp => !this.Employees.some((existingEmp: { SiteCode: any; }) => existingEmp.SiteCode === newEmp.SiteCode));
          this.Employees = [...this.Employees, ...uniqueNewEmployees];
          const rowCount = uniqueNewEmployees.length;
          this.toast.show({ message: `${rowCount} Site Added to the List!`, type: toastTypeEnum.success });
          this.isDisabled = false;
          console.log(data);
        },
        error => {
          console.error('Error:', error);
          this.isDisabled = false;
        }
      );
    }
  }

  downloadExcel() {
    if (this.WebESSApplicabilityId == 8) {
      this.download.downloadExcel('EmployeeApprovalSample');
    } else if (this.WebESSApplicabilityId == 4) {
      this.download.downloadExcel('SiteApprovalSample');
    }
  }

  async ESS_EmployeeSubcontracterSelect() {
    this.isDisabled = true;
    this.employeeRegistration.ESS_EmployeeSubcontracterSelect({ SelectType: "EW", EmpCode: this.Filter.SearchText, SubType: 'A' }).subscribe({
      next: async (response) => {
        if (response.Table != undefined && response.Table.length > 0) {
          response.Table.forEach((element: any) => {
            this.Employees.push({
              "BranchName": element.BranchName,
              "CustomerGroup": element.ClientGroupName,
              "SiteName": element.SiteName,
              "EmpMasterID": element.EmpMasterID,
              "EmpCode": element.EmpCode,
              "FullName": element.EmpCode + ' - ' + element.FirstName + ' ' + element.LastName,
              "Photo": element.Photo,
              "VendorId": element.VendorId,
              "VendorCode": element.VendorCode,
              "VendorName": element.VendorName,
            });
          });
          this.toast.show({ message: "Employee added in list", type: toastTypeEnum.success });
        } else {
          this.toast.show({ message: "Employee not found", type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

}
